import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { ErrorDialogContext, extractErrorInfo } from "@/shared/context/error-context";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { FixedWebWidthContentWrapper } from "@/shared/components/page/fixed-web-width-content-wrapper";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

export const ErrorPage = () => {
  const { error, setError } = useContext(ErrorDialogContext);

  const { title, message, errorCode } = extractErrorInfo(error);

  const navigate = useNavigate();

  return (
    <FixedWebWidthContentWrapper>
      <div className="error-page__header">
        <div className="error-page__header__leading">
          <BaseRoundButton
            // iconType={Icon.Close}
            onClick={() => {
              if (errorCode === 0x20500501 || errorCode === 0x20500502) {
                // パスワードリセット時のエラーは常にログイン画面へ戻す
                navigate(EndpointPathNames.LOGIN);
                setError(undefined);
              } else {
                navigate(-1);
                setError(undefined);
              }
            }}
          />
        </div>
        <p className="error-page__header__title">{title}</p>
        {/* タイトルを真ん中に配置するためのダミー */}
        <div className="error-page__header__trailing"></div>
      </div>

      <div className="error-page__frame">
        <p className="error-page__body">{message}</p>
      </div>

      <div className="mt32 pl16 pr16">
        <BaseRoundButton
          buttonText="ログイン画面に戻る"
          onClick={() => {
            navigate(EndpointPathNames.LOGIN);
            setError(undefined);
          }}
        />
      </div>
    </FixedWebWidthContentWrapper>
  );
};
